export type Prototype =
  | { label: string; kind: "internal" }
  | { label: string; kind: "external"; url: string }
  | { label: string; kind: "placeholder" };

export const fieldServicePrototypes: Prototype[] = [
  { label: "Route Planning", kind: "external", url: "https://route-planning.product-prototype-6gj.pages.dev/" },
  { label: "Invoice & Quotations", kind: "internal" },
];

export const cmmsPrototypes: Prototype[] = [
  { label: "Purchase Orders", kind: "external", url: "https://cmms-purchase-order.product-prototype-6gj.pages.dev/" },
];
